const state = {
  /** 新增学员页暂存，从学校管理返回时恢复 */
  addDraft: null
}

const mutations = {
  SET_ADD_DRAFT (state, payload) {
    state.addDraft = payload
  },
  CLEAR_ADD_DRAFT (state) {
    state.addDraft = null
  }
}

const actions = {
  saveAddDraft ({ commit }, payload) {
    commit('SET_ADD_DRAFT', payload)
  },
  clearAddDraft ({ commit }) {
    commit('CLEAR_ADD_DRAFT')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
